const Axios = require("axios");

exports.reCaptchaValidate = (token) => {
  return new Promise((resolve, reject) => {
    Axios.get(
      process.env.GATSBY_BACKEND_URL + "/siteVerify?token=" + token
    ).then((response) => {
      if (response.data.success) {
        resolve(true);
      } else {
        console.error("ReCaptcha Verify Error:", data);
        reject(false);
      }
    });
  });
};
